import { render, staticRenderFns } from "./ScenicList.vue?vue&type=template&id=bb9a39e6&scoped=true&"
import script from "./ScenicList.vue?vue&type=script&lang=js&"
export * from "./ScenicList.vue?vue&type=script&lang=js&"
import style0 from "./ScenicList.vue?vue&type=style&index=0&id=bb9a39e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9a39e6",
  null
  
)

export default component.exports